// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-cream {
  background-color: #fff8f0 !important;
}

.bg-header {
  background-color: #21252908;
}

.bg-lightBlue {
  background-color: #e8f0f3;
}

.bg-pink {
  background-color: #fff5f7 !important;
}

.bg-magenta {
  background-color: #c2185b;
  border-color: #c2185b;
  &:hover {
    background-color: #a1144b;
  }
  /* &:active {
        background: #c2185b;
    } */
}

.bg-magenta:hover {
  background-color: #a1144b;
}

.bg-magenta:active {
  background: #c2185b;
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #4caf50;
  --bs-btn-border-color: #4caf50;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #3e9142;
  --bs-btn-hover-border-color: #3e9142;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4caf50;
  --bs-btn-active-border-color: #4caf50;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #3e9142;
  --bs-btn-disabled-border-color: #3e9142;
}

.btn-outline-primary {
  --bs-btn-color: #4caf50;
  --bs-btn-border-color: #4caf50;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #3e9142;
  --bs-btn-hover-border-color: #3e9142;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4caf50;
  --bs-btn-active-border-color: #4caf50;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #3e9142;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #3e9142;
  --bs-gradient: none;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #424242;
  --bs-btn-border-color: #424242;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2e2e2e;
  --bs-btn-hover-border-color: #2e2e2e;
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #424242;
  --bs-btn-active-border-color: #424242;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #2e2e2e;
  --bs-btn-disabled-border-color: #2e2e2e;
}

.bg-green:hover {
  background-color: #3e9142;
  border-color: #3e9142;
}

.bg-gray {
  background-color: #424242; /* Emerald-Green */
  border: 1px solid #424242;
  color: #ffffff;
}

.bg-gray:hover {
  /* background-color: #3e9142;
  border-color: #3e9142; */
  /* transform: scale(1.03); */
}

.bg-orange {
  background-color: #ff8f00;
  border-color: #ff8f00;
}

.bg-skyBlue {
  background-color: #0277bd;
  border-color: #0277bd;
}

/* Optional: Disabled state */
.btn-primary:disabled,
.btn-secondary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.login-footer {
  font-size: 0.7rem;
}

btn-outline-primary {
  --bs-btn-color: #0277bd;
  --bs-btn-border-color: #0277bd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0277bd;
  --bs-btn-hover-border-color: #0277bd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0277bd;
  --bs-btn-active-border-color: #0277bd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0277bd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0277bd;
  --bs-gradient: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB;IACE,yBAAyB;EAC3B;EACA;;OAEK;AACP;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,gCAAgC;EAChC,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;0BACwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,gCAAgC;EAChC,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;AACrB","sourcesContent":[".bg-cream {\r\n  background-color: #fff8f0 !important;\r\n}\r\n\r\n.bg-header {\r\n  background-color: #21252908;\r\n}\r\n\r\n.bg-lightBlue {\r\n  background-color: #e8f0f3;\r\n}\r\n\r\n.bg-pink {\r\n  background-color: #fff5f7 !important;\r\n}\r\n\r\n.bg-magenta {\r\n  background-color: #c2185b;\r\n  border-color: #c2185b;\r\n  &:hover {\r\n    background-color: #a1144b;\r\n  }\r\n  /* &:active {\r\n        background: #c2185b;\r\n    } */\r\n}\r\n\r\n.bg-magenta:hover {\r\n  background-color: #a1144b;\r\n}\r\n\r\n.bg-magenta:active {\r\n  background: #c2185b;\r\n}\r\n\r\n.btn-primary {\r\n  --bs-btn-color: #fff;\r\n  --bs-btn-bg: #4caf50;\r\n  --bs-btn-border-color: #4caf50;\r\n  --bs-btn-hover-color: #fff;\r\n  --bs-btn-hover-bg: #3e9142;\r\n  --bs-btn-hover-border-color: #3e9142;\r\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\r\n  --bs-btn-active-color: #fff;\r\n  --bs-btn-active-bg: #4caf50;\r\n  --bs-btn-active-border-color: #4caf50;\r\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n  --bs-btn-disabled-color: #fff;\r\n  --bs-btn-disabled-bg: #3e9142;\r\n  --bs-btn-disabled-border-color: #3e9142;\r\n}\r\n\r\n.btn-outline-primary {\r\n  --bs-btn-color: #4caf50;\r\n  --bs-btn-border-color: #4caf50;\r\n  --bs-btn-hover-color: #fff;\r\n  --bs-btn-hover-bg: #3e9142;\r\n  --bs-btn-hover-border-color: #3e9142;\r\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\r\n  --bs-btn-active-color: #fff;\r\n  --bs-btn-active-bg: #4caf50;\r\n  --bs-btn-active-border-color: #4caf50;\r\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n  --bs-btn-disabled-color: #3e9142;\r\n  --bs-btn-disabled-bg: transparent;\r\n  --bs-btn-disabled-border-color: #3e9142;\r\n  --bs-gradient: none;\r\n}\r\n\r\n.btn-secondary {\r\n  --bs-btn-color: #fff;\r\n  --bs-btn-bg: #424242;\r\n  --bs-btn-border-color: #424242;\r\n  --bs-btn-hover-color: #fff;\r\n  --bs-btn-hover-bg: #2e2e2e;\r\n  --bs-btn-hover-border-color: #2e2e2e;\r\n  --bs-btn-focus-shadow-rgb: 130, 138, 145;\r\n  --bs-btn-active-color: #fff;\r\n  --bs-btn-active-bg: #424242;\r\n  --bs-btn-active-border-color: #424242;\r\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n  --bs-btn-disabled-color: #fff;\r\n  --bs-btn-disabled-bg: #2e2e2e;\r\n  --bs-btn-disabled-border-color: #2e2e2e;\r\n}\r\n\r\n.bg-green:hover {\r\n  background-color: #3e9142;\r\n  border-color: #3e9142;\r\n}\r\n\r\n.bg-gray {\r\n  background-color: #424242; /* Emerald-Green */\r\n  border: 1px solid #424242;\r\n  color: #ffffff;\r\n}\r\n\r\n.bg-gray:hover {\r\n  /* background-color: #3e9142;\r\n  border-color: #3e9142; */\r\n  /* transform: scale(1.03); */\r\n}\r\n\r\n.bg-orange {\r\n  background-color: #ff8f00;\r\n  border-color: #ff8f00;\r\n}\r\n\r\n.bg-skyBlue {\r\n  background-color: #0277bd;\r\n  border-color: #0277bd;\r\n}\r\n\r\n/* Optional: Disabled state */\r\n.btn-primary:disabled,\r\n.btn-secondary:disabled {\r\n  opacity: 0.65;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.login-footer {\r\n  font-size: 0.7rem;\r\n}\r\n\r\nbtn-outline-primary {\r\n  --bs-btn-color: #0277bd;\r\n  --bs-btn-border-color: #0277bd;\r\n  --bs-btn-hover-color: #fff;\r\n  --bs-btn-hover-bg: #0277bd;\r\n  --bs-btn-hover-border-color: #0277bd;\r\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\r\n  --bs-btn-active-color: #fff;\r\n  --bs-btn-active-bg: #0277bd;\r\n  --bs-btn-active-border-color: #0277bd;\r\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n  --bs-btn-disabled-color: #0277bd;\r\n  --bs-btn-disabled-bg: transparent;\r\n  --bs-btn-disabled-border-color: #0277bd;\r\n  --bs-gradient: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
